import React, { useContext, useEffect, useState } from 'react'
import {
  CButton,
  CCard,
  CCardBody,
  CCol,
  CContainer,
  CFormInput,
  CFormLabel,
  CRow,
} from '@coreui/react'
import { GlobalContext } from '../../context/GlobalState'
import { useHistory } from 'react-router-dom'
import { AppContext } from '../../context/app'
import { isEmpty } from 'lodash'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons'
import { RESET_USER_PASSWORD } from 'src/views/utils/urls'
// import { raiseToast } from 'src/views/utils/helper'
import useAxios from 'axios-hooks'
import SweetAlert from 'react-bootstrap-sweetalert'

const ResetPassword = (props) => {
  const [password, setPassword] = useState('')
  const [passwordHide, setPasswordHide] = useState(true)
  const [cnfPassword, setCnfPassword] = useState('')
  const [cnfPasswordHide, setCnfPasswordHide] = useState(true)
  const [successAlert, setSuccessAlert] = useState(false)
  const [errorData, setErrorData] = useState({})
  const { setLoader, accountObj } = useContext(AppContext)
  const { userObj, signedIn } = useContext(GlobalContext)

  let history = useHistory()

  const handleChange = (event, func) => {
    const { value } = event.target
    func(value)
  }

  const [{ data: resetPasswordData, loading: resetPasswordLoading }, resetPasswordCall] = useAxios(
    {
      url: RESET_USER_PASSWORD,
      method: 'put',
    },
    { manual: true },
  )

  const validateInfo = () => {
    let isFormValid = true
    let temp = {}

    if (!password && password.trim().length === 0) {
      isFormValid = false
      temp.password = 'Password cannot be Empty!'
    }

    if (password !== cnfPassword) {
      isFormValid = false
      temp.cnfPassword = 'Confirm Password should be same as that of password!'
    }

    setErrorData({ ...temp })
    return isFormValid
  }
  const handleResetPassword = () => {
    if (validateInfo()) {
      resetPasswordCall({
        data: {
          user_id: userObj._id,
          password: password,
        },
      })
    }
  }

  useEffect(() => {
    setLoader(resetPasswordLoading)
  }, [resetPasswordLoading])

  useEffect(() => {
    if (resetPasswordData && resetPasswordData.success) {
      setSuccessAlert(true)
    }
  }, [resetPasswordData])

  useEffect(() => {
    if (signedIn && !userObj?.is_forced_password_reset && !isEmpty(accountObj)) {
      console.log('i am here')
      let x = props.location.state
      console.log('i am here', x)
      history.push(x === undefined || x === '/login' ? '/' : x)
    }

    if (!signedIn) {
      history.push('/login')
    }
  }, [signedIn, accountObj])

  const handleConfirm = () => {
    window.location.reload()
  }

  return (
    <div className="bg-light min-vh-100 d-flex flex-row align-items-center">
      <CContainer>
        <CRow className="justify-content-center">
          <CCol md="6">
            {/* <CCardGroup> */}
            <CCard className="p-4">
              <CCardBody>
                <h1> Reset Password</h1>
                <CRow className="mt-3">
                  <CCol style={{ position: 'relative' }}>
                    <CFormLabel>Password*</CFormLabel>
                    <CFormInput
                      type={passwordHide ? 'password' : 'text'}
                      value={password}
                      name="password"
                      onChange={(e) => handleChange(e, setPassword)}
                    />
                    <div
                      style={{
                        position: 'absolute',
                        right: '5%',
                        top: errorData.password ? '45%' : '55%',
                      }}
                    >
                      {!passwordHide ? (
                        <FontAwesomeIcon
                          icon={faEye}
                          size="lg"
                          onClick={() => setPasswordHide(true)}
                        />
                      ) : (
                        <FontAwesomeIcon
                          icon={faEyeSlash}
                          size="lg"
                          onClick={() => setPasswordHide(false)}
                        />
                      )}
                    </div>
                    <div className="message-text error-message">
                      <p>{errorData.password}</p>
                    </div>
                  </CCol>
                </CRow>
                <CRow className="mt-3">
                  <CCol style={{ position: 'relative' }}>
                    <CFormLabel>Confirm Password*</CFormLabel>
                    <CFormInput
                      type={cnfPasswordHide ? 'password' : 'text'}
                      value={cnfPassword}
                      name="password"
                      onChange={(e) => handleChange(e, setCnfPassword)}
                    />
                    <div
                      style={{
                        position: 'absolute',
                        right: '5%',
                        top: errorData.cnfPassword ? '45%' : '55%',
                      }}
                    >
                      {!cnfPasswordHide ? (
                        <FontAwesomeIcon
                          icon={faEye}
                          size="lg"
                          onClick={() => setCnfPasswordHide(true)}
                        />
                      ) : (
                        <FontAwesomeIcon
                          icon={faEyeSlash}
                          size="lg"
                          onClick={() => setCnfPasswordHide(false)}
                        />
                      )}
                    </div>
                    <div className="message-text error-message">
                      <p>{errorData.cnfPassword}</p>
                    </div>
                  </CCol>
                </CRow>
                <CRow className="mt-3">
                  <CCol className="d-flex justify-content-end">
                    <CButton color="info" className="text-white" onClick={handleResetPassword}>
                      Reset Password
                    </CButton>
                  </CCol>
                </CRow>
              </CCardBody>
            </CCard>
          </CCol>
        </CRow>
      </CContainer>
      {successAlert && (
        <SweetAlert
          type={`success`}
          title={`Password Reset Successfully`}
          onConfirm={handleConfirm}
        />
      )}
    </div>
  )
}

export default ResetPassword
